import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Form,
  Select,
  Input,
  Tag,
  notification,
} from "antd";
import { del, get, post } from "../../../api/axios";
import { Link } from "react-router-dom";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";
import { onChangeTableHelper } from "../../control-sections/helper/TableHelpers";
import TableComponent from "../../control-sections/helper/TableComponent";
import { DeleteOutlined, EyeOutlined, EditOutlined } from "@ant-design/icons";

const Sellers = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [total, setTotal] = useState(1);

  const [filterData, setFilterData] = useState({
    filter_key: "",
    filter_value: "",
  });

  const [sorter, setSorter] = useState({
    sort_by: "",
    order: "",
  });

  const [selectedSellers, setSelectedSellers] = useState({
    sellers: [],
  });

  const columns = [
    {
      title: " Id",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name - b.name,
    },
    {
      title: "Full Phone Number",
      dataIndex: "full_phone_number",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email - b.email,
    },
    {
      title: "Active",
      render: ({ is_active }) => (
        <>
          <Tag color={`${is_active == 1 ? "success" : "error"}`}>
            {is_active == 1 ? "Active" : "Inactive"}
          </Tag>
        </>
      ),
    },
    {
      title: "Nafath Check Status",
      dataIndex: "nafath_status",
      sorter: (a, b) => a.nafath_status - b.nafath_status,
    },
    {
      title: "Nafath Code",
      dataIndex: "nafath_code",
      sorter: (a, b) => a.nafath_code - b.nafath_code,
    },
  ];

  if (checkPermission("show-seller") || checkPermission("update-seller")) {
    columns.push({
      title: "Actions",
      dataIndex: "id",
      render: (id) => (
        <div>
          {checkPermission("show-seller") && (
            <Button className="btn btn-outline-secondary btn-edit btn-sm p-0 me-3">
              <Link
                className="color-inherit text-decoration-none py-1 px-2 d-block"
                to={`/sellers/show/${id}`}
              >
                <EyeOutlined />
              </Link>
            </Button>
          )}

          {checkPermission("update-seller") && (
            <Button className="btn btn-outline-warning btn-edit btn-sm p-0 me-3">
              <Link
                className="color-inherit text-decoration-none py-1 px-2 d-block"
                to={`/sellers/edit/${id}`}
              >
                <EditOutlined />
              </Link>
            </Button>
          )}
        </div>
      ),
    });
  }

  useEffect(() => {
    get("sellers?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
      setLoading(false);
    });
  }, []);

  const handleFilterKey = (e) => {
    setFilterData({ ...filterData, filter_key: e });
  };

  const handleFilterVal = (e) => {
    setFilterData({ ...filterData, [e.target.id]: e.target.value });
  };

  const onFilter = (values) => {
    setLoadingSearch(true);

    get(
      `sellers?filter_key=${filterData.filter_key}&filter_value=${
        filterData.filter_value
      }${
        sorter.sort_by !== "" && sorter.sort_by !== undefined
          ? `&sort_by=${sorter.sort_by}`
          : ""
      }${sorter.order !== "" ? `&order=${sorter.order}` : ""}`
    )
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoadingSearch(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoadingSearch(false);
      });
  };

  const clearSearch = () => {
    form.resetFields();
    setFilterData({
      filter_key: "",
      filter_value: "",
    });
    get("sellers?page=1&limit=50").then((res) => {
      setData(res.data.data);
      setTotal(res.data.meta.total);
    });
  };

  const onChangeTable = (pagination, filters, sorter) => {
    setLoading(true);
    setSorter({
      ...sorter,
      sort_by: sorter.field,
      order: sorter.order == "descend" ? "desc" : "asc",
    });

    onChangeTableHelper("sellers", pagination, filterData, sorter)
      .then((res) => {
        setData(res.data.data);
        setTotal(res.data.meta.total);
        setLoading(false);
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response.data.message,
        });
        setLoading(false);
      });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedSellers({
        sellers: selectedRowKeys,
      });
    },
    getCheckboxProps: (record) => ({
      name: record.id,
    }),
  };

  const bulkBlockandUnBlockUsellers = (type) => {
    if (selectedSellers.sellers.length > 0) {
      post(`users-bulk-action`, {
        users: selectedSellers.sellers,
        action: "is_active",
        value: type == 1 ? true : false,
      })
        .then((res) => {
          notification.success({
            message: `Sellers ${
              type == 1 ? "activated successfully" : "inactived successfully"
            }`,
          });

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((err) => {
          notification.error({
            message: "Error!",
            description: err.response.data.message,
          });
          setLoading(false);
        });
    } else {
      notification.error({ message: "must select one or more sellers" });
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <Title level={2} className="text-main mb-2">
                Sellers Management
              </Title>
            </div>
            {checkPermission("update-user") && total > 0 ? (
              <>
                <div className="col-lg-3 offset-lg-3 text-end">
                  <Button
                    type="primary"
                    onClick={() => bulkBlockandUnBlockUsellers(1)}
                    className="p-2 mb-2"
                    size="large"
                  >
                    Active
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => bulkBlockandUnBlockUsellers(0)}
                    className="p-2 mb-2 ms-2"
                    size="large"
                  >
                    Inactive
                  </Button>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <div className="grid-margin stretch-card wrapper-content">
        <Form onFinish={onFilter} layout="vertical" form={form}>
          <div className="row">
            <div className="col-12 col-lg-4">
              <Form.Item
                label="Search By"
                name="filter_key"
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Select
                  className="w-100"
                  showSearch
                  placeholder="select test "
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onChange={handleFilterKey}
                  options={[
                    {
                      value: "name",
                      label: "Name",
                    },
                    {
                      value: "phone_number",
                      label: "Phone Number",
                    },
                    {
                      value: "is_active",
                      label: "Is Active",
                    },
                    {
                      value: "id",
                      label: "Id",
                    },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-6">
              <Form.Item
                label="Search"
                name="filter_value"
                onChange={handleFilterVal}
                rules={[
                  {
                    required: true,
                    message: "This field is required!",
                  },
                ]}
              >
                <Input placeholder="Type to search..." />
              </Form.Item>
            </div>
            <div className="col-12 col-lg-2 d-flex align-items-end">
              <Form.Item className="w-100">
                <div className="row">
                  <div className="col-8">
                    <Button
                      block
                      loading={loadingSearch}
                      type="primary"
                      htmlType="submit"
                    >
                      {loadingSearch ? "Searching" : "Search"}
                    </Button>
                  </div>
                  <div className="col-4">
                    <Button
                      onClick={clearSearch}
                      className="flex-center"
                      danger
                      type="primary"
                    >
                      <DeleteOutlined />
                    </Button>
                  </div>
                </div>
              </Form.Item>
            </div>
          </div>
        </Form>
        <TableComponent
          onChangeTable={onChangeTable}
          loading={loading}
          columns={columns}
          data={data}
          total={total}
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
        />
      </div>
    </div>
  );
};

export default Sellers;
